/**
 * スクロール時にヘッダーをスティッキーデザインに切り替える
 * 下層ページでは常にスクロール済み状態を維持する
 */
function stickyHeader() {
  const header = document.getElementById('js-header');
  if (!header) return;

  const isTopPage = document.body.classList.contains('home');

  if (!isTopPage) {
    header.classList.add('is-sticky', 'is-sticky--instant');
    return;
  }

  const fv = document.querySelector('.m-fv');

  function updateHeader() {
    const threshold = fv ? fv.offsetTop + fv.offsetHeight : 0;
    if (window.scrollY > threshold) {
      header.classList.add('is-sticky');
    } else {
      header.classList.remove('is-sticky');
    }
  }

  window.addEventListener('scroll', updateHeader, { passive: true });
  updateHeader();
}

export { stickyHeader };
